import { lazy, type LazyExoticComponent } from 'react';

import type { ConversationAssistantUIProps } from './ConversationAssistantUI';
import { importConversationAssistantUI } from './import-conversation-assistant-ui';

/**
 * The chat UI behind a `lazy()` boundary, rendered by `ConversationAssistantConfigurer`.
 *
 * The configurer may not import `ConversationAssistantUI` statically: it is itself statically
 * imported by `ConversationAssistant.tsx`, so a static import would pull the UI graph into the
 * shared parent chunk and every mount would download it — including the `skipChatUI` mounts that
 * never render it.
 */
export const ConversationAssistantUILazy: LazyExoticComponent<
	(props: ConversationAssistantUIProps) => React.JSX.Element
> = lazy(() =>
	importConversationAssistantUI().then((module) => ({
		default: module.ConversationAssistantUI,
	})),
);
